import { environment } from 'src/environment';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import {  NgIf } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink]
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  logo: string;
  homeImage: any;
  isEmbed = false;
  @Input() errorResult;

  skinName = environment.skinName;
  constructor(public settingsService: SettingsService,
    public configService: ConfigurationService, private storageService:StorageService) { 
      this.isEmbed = this.storageService.getSessionStore('embed');
      if(this.isEmbed){
        this.settingsService.showHeader = false;
        this.settingsService.showFooter = false;
      }
    }

  ngOnInit(): void {
    this.settingsService.showHeader = false;
    this.logo = this.settingsService.logo;
    this.homeImage = this.settingsService.homeImage;
  }

  ngOnDestroy() {
    this.settingsService.showHeader = true;
  }

}
